import { useNavigate, useLocation } from 'react-router-dom';
import { ChatCircleDots } from '@phosphor-icons/react';
import { useAuth, canUseApp } from '@/auth/AuthContext';
import { useChatUnread } from '@/hooks/useChatUnread';
import { useT } from '@/i18n/LanguageContext';

/** Global floating chat button (desktop/tablet only — on mobile the BottomTabBar
 * provides the チャット tab, so the FAB is hidden <md to avoid duplication).
 * Hidden on the chat page and /login. */
export default function ChatFab() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useT();
  const unread = useChatUnread(user);

  const authed = !!user && typeof user === 'object';
  const p = location.pathname;
  if (!authed || p === '/login' || p.startsWith('/s/') || p.startsWith('/g/') || p.startsWith('/b/') || p.startsWith('/chat') || p.startsWith('/mfg/kiosk') || !canUseApp(user, 'chat')) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/chat')}
      data-testid="chat-fab"
      aria-label={t('nav.chat')}
      className="group fixed bottom-24 right-5 md:bottom-6 md:right-6 z-30 hidden md:inline-flex items-center justify-center gap-2.5 h-16 w-16 sm:w-auto sm:px-6 rounded-full bg-teal-700 text-white shadow-xl shadow-[#0052FF]/40 ring-4 ring-teal-700/15 transition-all duration-200 hover:bg-teal-800 hover:scale-105 active:scale-95"
    >
      {unread > 0 && (
        <span className="absolute inset-0 rounded-full bg-teal-700 opacity-20 animate-ping pointer-events-none" />
      )}
      <ChatCircleDots size={28} weight="fill" className="shrink-0" />
      <span className="hidden sm:inline text-sm font-semibold">{t('nav.chat')}</span>
      {unread > 0 && (
        <span
          data-testid="chat-fab-badge"
          className="absolute -top-1 -right-1 min-w-[22px] h-[22px] px-1.5 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center ring-2 ring-white"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
